import {
  Box,
  Button,
  Card,
  CardHeader,
  Divider,
  Grid,
  List,
  ListItem,
  ListItemText,
  TextField,
  Typography,
} from "@mui/material";
import SendIcon from "@mui/icons-material/Send";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { getUser } from "../services/authService";
import {
  addComment,
  getAllComments,
  sendEmailForComment,
} from "../services/dataService";

function CommentBox2({ POID, FormName }) {
  const [commentText, setCommentText] = useState("");
  const [newComments, setNewComments] = useState([]);
  const user = getUser();

  const handleChange = (event) => {
    setCommentText(event.target.value);
  };

  const handleAddComment = async () => {
    try {
      await addComment({
        Comment: commentText,
        FormName,
        Id: POID,
        ActualCommentDate: moment().format().toString().split("+")[0],
      });
      toast.success("Comment sent");
      const response = await getAllComments({
        FormName: FormName,
        Id: POID,
      });
      setNewComments(response.data);
      setCommentText("");
      await sendEmailForComment(POID);
    } catch (error) {
      toast.error("Unable to add comment");
    }
  };
  
  useEffect(() => {
    async function requestAllComments() {
      try {
        const response = await getAllComments({
          FormName: FormName,
          Id: POID,
        });
        setNewComments(response.data);
      } catch (error) {}
    }
    requestAllComments();
  }, [FormName, POID]);

  return (
    <>
      <Grid container sx={{ mt: 2 }} boxShadow={3} lg={12}>
        <Card sx={{ width: "100%", maxHeight: "400px" }}>
          <CardHeader
            title={
              <>
                <Typography variant="body2">Comments({newComments.length})</Typography>
              </>
            }
            mb={1}
          />
          <Divider />
          <Grid
            item
            overflow="auto"
            display="flex"
            flexDirection="column-reverse"
            lg={12}
            width="100%"
            height="200px"
            mt={1}
          >
            {newComments.map((item) => {
              return (
                <List
                  sx={{
                    width: "100%",
                    maxWidth: 370,
                    bgcolor: "background.paper",
                  }}
                >
                  <ListItem
                    alignItems="flex-end"
                    width="70%"
                    sx={{ borderBottom: "1px solid  #D3D3D3", paddingTop: "0" }}
                  >
                    <ListItemText
                      primary={
                        <React.Fragment>
                          <Grid container>
                            <Grid item lg={8}>
                              <Typography
                                variant="body2"
                                color="rgb(29,146,255)"
                                fontSize="15px"
                                fontWeight={500}
                              >
                                {item.LoginId === user?.userDetails.LoginId
                                  ? "You"
                                  : item.LoginId}
                              </Typography>
                            </Grid>
                            <Grid item lg={4}>
                              <Typography
                                textAlign="right"
                                fontSize="12px"
                                color="text.primary"
                                sx={{ paddingTop: "3px" }}
                              >
                                {moment(item.ActualCommentDate).format(
                                  "MMM DD h:mm A"
                                )}
                              </Typography>
                            </Grid>
                          </Grid>
                        </React.Fragment>
                      }
                      secondary={item.Comment}
                    />
                  </ListItem>
                </List>
              );
            })}
          </Grid>
          <Divider></Divider>
          <Grid
            item
            width="100%"
            lg={12}
            sx={{ backgroundColor: "@D3D3D3", display: "inline" }}
          >
            <Box sx={{ border: "1px solid gray", m: 1, borderRadius: "5px" }}>
              <TextField
                variant="standard"
                placeholder="Write a comment"
                value={commentText}
                sx={{
                  backgroundColor: "white",
                  borderRadius: "5",
                  m: 1,
                  mt: 1,
                  width: "280px",
                  border: "null",
                }}
                InputProps={{
                  disableUnderline: "true",
                }}
                onChange={handleChange}
              ></TextField>
              <Button
                sx={{ mt: "6px", ml: "2px" }}
                variant="Text"
                color="primary"
                onClick={handleAddComment}
                pr={1}
              >
                <SendIcon />
              </Button>
            </Box>
          </Grid>
        </Card>
      </Grid>
    </>
  );
}

export default CommentBox2;
